
import AppBrowse from "@/components/browse/SearchBrowse.vue";
import { Sale } from "@/models/base";
import { BookYearService } from "@/services/book-year-service";
import { BrowseService } from "@/services/browse-service";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import { IQueryParams } from "@/utils/query-params";
import { TranslateResult } from "vue-i18n";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";
import { HumanFilter } from "@/utils/human-filter";
import {UserConfigService, ViewService} from "@/services";
import {BookYear} from "@/models/book-year";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as Sale[],
			bookYears: BookYearService.bookYears,
			refresh: 0,
			selectedBookYear: BookYearService.selectedBookYear,
			filterOnCurrentContactEnabled: true,
			filterOnAlreadyImportedEnabled: false,
			buttonDisabled: false,
			view: null as View | null,
			generalSettings: UserConfigService.getGeneralSettings(),
		};
	},
	props: {
		contactId: {
			type: Number,
			default: 0
		},
		contactGroupId: {
			type: Number,
			required: true
		},
		disableContactFilter: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		confirmDisabled():boolean {
			if (this.selectedItems.length == 0) {
				return true;
			}
			return this.buttonDisabled;
		},
		shouldFilterOnCurrentContact():boolean {
			if (this.disableContactFilter) {
				return false;
			}
			return this.filterOnCurrentContactEnabled;
		},
		dataSource(): IBrowseBaseDataSource<Sale> {
			let f:HumanFilter[] = [
				new HumanFilter({Field: "this.ComputedFriendlyID", Operator: "!^", Values: ["-"]})
			];
			if(this.filterOnAlreadyImportedEnabled){
				f.push(new HumanFilter({
					Field: "this.HasBeenImportedInOtherSale",
					Operator: "=",
					Values: ["0"],
				}));
			}

			let getElements = (params:IQueryParams) => SaleService.getSalesByContactID(this.contactId, params, `${this.selectedBookYear}`,f);
			if (this.contactGroupId == 2){
				getElements = (params:IQueryParams) => SaleService.getPurchaseByContactID(this.contactId, params, `${this.selectedBookYear}`);
			}else if (this.contactGroupId == 3) {
				getElements = (params:IQueryParams) => SaleService.getSalesByContactID(this.contactId, params, `${this.selectedBookYear}`);
			}
			if (!this.shouldFilterOnCurrentContact){
				getElements = (params:IQueryParams) => SaleService.getSales(params, `${this.selectedBookYear}`,f);
				if (this.contactGroupId == 2){
					getElements = (params:IQueryParams) => SaleService.getPurchaseDocuments(params, `${this.selectedBookYear}`);
				}else if (this.contactGroupId == 3) {
					getElements = (params:IQueryParams) => SaleService.getSales(params, `${this.selectedBookYear}`);
				}
			}
			return {
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements,
				async getTotals(view:View):Promise<FetchedTotal[]>{
					return [];
				},
				browseName: "Sales",
				modelName: "Sale",
				ignorePreferedView: true
			};
		},
		browseId():number{
			if (this.contactGroupId == 2){
				return 12;
			}else if(this.contactGroupId == 3) {
				return 6;
			}
			return 6;
		},
		sortedBookYearItems(): BookYear[]{
			let b = [...this.bookYears];
			return b.sort((a: BookYear, b: BookYear): number => b.Year - a.Year);
		},
		bookYearItems(): ISelectItem<number>[] {
			return this.sortedBookYearItems.map((b) => {
				return {
					text: b.Year + "",
					value: b.Year
				};
			});
		},
		filterOnCurrentContactIcon():string{
			if (this.filterOnCurrentContactEnabled){
				return "users-slash";
			}
			return "users";
		},
		filterOnCurrentContactTooltip():TranslateResult{
			if (this.filterOnCurrentContactEnabled){
				return this.$ct("show-all-documents");
			}
			return this.$ct("filter-documents-on-client");
		},
		filterOnCurrentImportTooltip():TranslateResult{
			if (this.filterOnAlreadyImportedEnabled){
				return this.$ct("show-all-documents");
			}
			return this.$ct("filter-documents-on-already-imported");
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		select() {
			this.buttonDisabled = true;
			this.$emit("select", this.selectedItems);
		},
		onSelectChanged(value:Sale[]){
			this.selectedItems = value;
		},
		onBookYearChange(bookyear:number) {
			this.selectedBookYear = bookyear;
			this.refresh++;
		}
	},
	async mounted(){
		if(this.generalSettings.DefaultSalesF3Browse>0){
			this.view = await ViewService.getView(this.generalSettings.DefaultSalesF3Browse);
		}
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
